import { Component, OnInit, Input } from '@angular/core';
import { WizardService } from '../../../../service/wizard/wizard.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: '[app-wizard]',
  templateUrl: 'wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
})
export class WizardComponent implements OnInit {
  private _totalSteps: number;
  steps = [];
  subscription: Subscription;
  active: number = 1;

  constructor(private wizardService: WizardService) {}

  @Input() set totalSteps(value: number) {
    this.steps = [];
    for (let index = 0; index < value; index++) {
      this.steps.push('0' + (index + 1).toString());
    }
    this._totalSteps = value;
  }

  get totalStepsValue(): number {
    return this._totalSteps;
  }

  ngOnInit() {
    const tipo = localStorage.getItem('tipo');
    this._totalSteps = tipo === 'fisica' ? 2 : 3;

    this.steps = [];
    for (let index = 0; index < this._totalSteps; index++) {
      this.steps.push('0' + (index + 1).toString());
    }

    this.wizardService.index$.subscribe(index => {
      this.active = index;
    });

    console.log('Tipo:', tipo, 'Total Steps:', this._totalSteps);
  }
}
